/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationMedicineMaterialsAliases {
  ACTION_ADD = 'action-add',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_0 = 'deck-0',
  FETCH_MEDICINE_MATERIAL = 'fetch-medicine-material',
  FETCH_MEDICINE_MATERIALS_LIST = 'fetch-medicine-materials-list',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_10 = 'field-10',
  FIELD_CODE = 'field-code',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_MEDICINE_MATERIAL = 'field-medicine-material',
  FIELD_MEDICINE_MATERIAL_VALUE = 'field-medicine-material-value',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  FORM_MEDICINE_MATERIAL = 'form-medicine-material',
  FORM_PENDENCIES = 'form-pendencies',
  HPMS_CUSTOM_CARD_MEDICINE_MATERIALS = 'hpms-custom-card-medicine-materials',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_MEDICINE_MATERIAL_CODE = 'input-medicine-material-code',
  INPUT_MEDICINE_MATERIAL_VALUE = 'input-medicine-material-value',
  LAYOUT_MEDICINE_MATERIALS = 'layout-medicine-materials',
  LOCATOR_FIELD_MEDICINE_MATERIAL = 'locator-field-medicine-material',
  LOCATOR_MEDICINE_MATERIAL = 'locator-medicine-material',
  MAPPER_10 = 'mapper-10',
  MODAL_MATERIAL = 'modal-material',
  PANEL_LIST_MEDICINE_MATERIALS = 'panel-list-medicine-materials',
  PANEL_MEDICINE_MATERIALS = 'panel-medicine-materials',
  PANEL_MODAL = 'panel-modal',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProviderAccreditationMedicineMaterialsAliases };
